module.exports = __webpack_public_path__ + "media/coffee5.2f2c82ad.mp4";